/**
 * Warranty — renderer (frontend). Same shape as PurchaseOrder.tsx.
 * Reads the snapshot payload produced by backend/document-sharing/types/warranty.js.
 */
import type { DocumentProps, FrontendDocumentDefinition } from '../registry';
import { BaseDocumentLayout } from '../BaseDocumentLayout';

const MUTED = 'rgb(var(--gray-500))'; // was #6b7280 — exact match to --gray-500 token

export const documentDefinition: FrontendDocumentDefinition = {
  docType: 'warranty',
  renderer: Warranty,
  appRoute: '/project-management/warranties',
};

export function Warranty({ payload }: DocumentProps) {
  const w = payload?.warranty || {};
  const project = payload?.project || null;
  const client = payload?.client || null;
  const assigneeName = payload?.assignee_name || 'Not assigned';

  return (
    <BaseDocumentLayout
      title="WARRANTY"
      reference={w.title}
      meta={[{ label: 'Status', value: w.status }]}
    >
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24, marginBottom: 20 }}>
        <div style={{ flex: '1 1 240px' }}>
          {/* gap: this field-label style (fontSize 11 / uppercase / marginBottom 4) is
              repeated identically across all 6 document templates — candidate for a
              shared "doc field label" token/class, not added here per scope. */}
          <div style={{ fontSize: 11, textTransform: 'uppercase', color: MUTED, marginBottom: 4 }}>Project</div>
          <div style={{ fontWeight: 600 }}>{project?.name || '—'}</div>
        </div>
        <div style={{ flex: '1 1 240px' }}>
          <div style={{ fontSize: 11, textTransform: 'uppercase', color: MUTED, marginBottom: 4 }}>Client</div>
          <div style={{ fontWeight: 600 }}>{client?.name || 'Client'}</div>
          {client?.email && <div style={{ color: MUTED }}>{client.email}</div>}
        </div>
        <div style={{ flex: '1 1 240px' }}>
          <div style={{ fontSize: 11, textTransform: 'uppercase', color: MUTED, marginBottom: 4 }}>Assignee</div>
          <div style={{ fontWeight: 600 }}>{assigneeName}</div>
        </div>
      </div>

      {w.claim && (
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 11, textTransform: 'uppercase', color: MUTED, marginBottom: 4 }}>Claim</div>
          <div style={{ whiteSpace: 'pre-wrap' }}>{w.claim}</div>
        </div>
      )}

      {w.response && (
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 11, textTransform: 'uppercase', color: MUTED, marginBottom: 4 }}>Response</div>
          <div style={{ whiteSpace: 'pre-wrap' }}>{w.response}</div>
        </div>
      )}
    </BaseDocumentLayout>
  );
}
